import Axios from 'axios'
import { createSimpleStore } from 'react-simple-reducer'
import api from '../api'

export type TMenuOptions =
  | 'Alunos'
  | 'Cursos'
  | 'Turmas'
  | 'Isencoes'
  | 'detran-logs'
  | 'detran-actions'
  | 'notas-fiscais'
  | 'Cupons'
  | 'certificados'
  | 'portal-artigos'
  | 'bi'
  | 'parceiros'

export const StoreHome = createSimpleStore(
  {
    menuOptionSelected: 'Alunos' as TMenuOptions,
    certificadosPendentesTotal: 0,
    loadingCertificadosPendentes: false,
    solicitacoesTurmaTotal: 0,
  },
  {
    changeMenuOptionSelected: (state, option: TMenuOptions) => ({
      ...state,
      menuOptionSelected: option,
    }),
    fetchCertificadosPendentesStarted: (state) => ({
      ...state,
      loadingCertificadosPendentes: true,
    }),
    fetchCertificadosPendentesSuccess: (state, total: number) => ({
      ...state,
      certificadosPendentesTotal: total,
      loadingCertificadosPendentes: false,
    }),
    fetchCertificadosPendentesFailed: (state) => ({
      ...state,
      loadingCertificadosPendentes: false,
    }),
    setSolicitacoesTurmaTotal: (state, total: number) => ({
      ...state,
      solicitacoesTurmaTotal: total,
    }),
  },
  {
    thunks: {
      getCertificadosPendentesTotal() {
        return async (dispatch) => {
          dispatch(StoreHome.actions.fetchCertificadosPendentesStarted())
          try {
            const { data } = await Axios.get('/certificados/pendentes')
            const total = (data ?? []).filter(
              (matricula: { uf: string }) => matricula.uf === 'DF' || matricula.uf === 'MG'
            ).length
            dispatch(StoreHome.actions.fetchCertificadosPendentesSuccess(total))
          } catch {
            dispatch(StoreHome.actions.fetchCertificadosPendentesFailed())
          }
        }
      },
      getSolicitacoesTurmaTotal() {
        return async (dispatch) => {
          try {
            const { total } = await api.Turmas.contarSolicitacoes()
            dispatch(StoreHome.actions.setSolicitacoesTurmaTotal(total))
          } catch {
            dispatch(StoreHome.actions.setSolicitacoesTurmaTotal(0))
          }
        }
      },
    },
  }
)

export type TStore = ReturnType<typeof StoreHome.useState>
